import {
  QueryClient,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  fetchListFlowCategories,
  fetchListFlowCategory,
  fetchParcel,
} from '~/api/listFlow';
import { RailsCategory, RailsParcel } from '~/typings/services/rails/item';

/**
 *
 * @param queryClient Should be the shared query client
 */
export function prefetchListFlowCategories(queryClient: QueryClient) {
  return queryClient.fetchQuery(
    ['list-flow-categories'],
    fetchListFlowCategories,
    {
      staleTime: Infinity,
    },
  );
}

export function useListFlowCategories(): UseQueryResult<RailsCategory[]> {
  return useQuery(['list-flow-categories'], fetchListFlowCategories, {
    staleTime: Infinity,
  });
}

/**
 *
 * @param queryClient Should be the shared query client
 * @param categoryId
 */
export function prefetchListFlowCategory(
  queryClient: QueryClient,
  categoryId: number | string,
) {
  return queryClient.fetchQuery(
    ['list-flow-categories', categoryId],
    () => fetchListFlowCategory(categoryId),
    {
      staleTime: Infinity,
    },
  );
}

export function useListFlowCategory(
  categoryId?: number | string,
  options?: UseQueryOptions<RailsCategory>,
): UseQueryResult<RailsCategory> {
  return useQuery<RailsCategory>(
    ['list-flow-categories', categoryId],
    () => fetchListFlowCategory(categoryId!),
    {
      enabled: !!categoryId,
      staleTime: Infinity,
      ...options,
    },
  );
}

export function prefetchListFlowParcel(
  queryClient: QueryClient,
  categoryId: number,
  detailIds: number[],
) {
  return queryClient.fetchQuery(
    ['list-flow-parcel', categoryId, detailIds],
    () => fetchParcel(categoryId, detailIds),
    {
      staleTime: Infinity,
    },
  );
}

export function useListFlowParcel(
  categoryId?: number,
  detailIds?: number[],
  options?: UseQueryOptions<RailsParcel>,
): UseQueryResult<RailsParcel> {
  return useQuery<RailsParcel>(
    ['list-flow-parcel', categoryId, detailIds],
    () => fetchParcel(categoryId!, detailIds!),
    {
      enabled: !!categoryId && !!detailIds,
      staleTime: Infinity,
      ...options,
    },
  );
}
